module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-35.6a19a567.png";